import {get, post} from '@/axios';

export const getAllDevice = p => get('dynamic/getAllDevice', p);

export const getCompanyCountInfo = p => get('deviceStatistic/getList', p);

export const getAllOnlineStatusCount = p => get('deviceStatistic/getAllOnlineStatusCount', p);

export const getAllStautsDevices = p => get('deviceStatistic/getAllStatusCount', p);


// WEBPACK FOOTER //
// ./src/api/device/deviceMap.js